var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDataWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 200,
    viewBox: "0 0 234 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.072 8.34832C158.072 8.34832 126.11 48.8338 74.9712 24.6849C23.8324 0.536034 -27.3065 65.8801 16.7298 105.655C60.7661 145.429 17.6733 167.285 47.5897 191.662C81.5918 219.368 111.195 163.186 138.184 175.971C197.752 204.187 241.882 193.017 231.939 160.345C214.484 102.993 192.165 99.2628 209.211 69.4313C226.256 39.5998 188.636 -22.4256 158.072 8.34832Z",
    fill: "#DEE9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.152 94.8854V179.823L50.2051 151.339L50.5197 66.7082L116.152 94.8854Z",
    fill: "#699CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.153 94.9362V179.874L181.78 152.373V66.9792L116.153 94.9362Z",
    fill: "#84AEFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.152 94.8854L182.1 67.2636L116.67 38.2606L50.2051 66.5731L116.152 94.8854Z",
    fill: "#699CFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1963 81.725L98.5635 113.939C98.7419 114.026 98.9437 114.051 99.138 114.012C99.3324 113.972 99.5084 113.87 99.6391 113.721L116.153 94.8852L50.2054 66.5729L32.0486 80.1868C31.9245 80.2799 31.8263 80.4033 31.7637 80.5453C31.701 80.6872 31.6758 80.8429 31.6907 80.9973C31.7055 81.1518 31.7598 81.2998 31.8483 81.4273C31.9369 81.5547 32.0567 81.6572 32.1963 81.725Z",
    fill: "#0E84E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.1 67.2635L200.415 83.8223C200.527 83.9233 200.612 84.0506 200.662 84.1926C200.712 84.3347 200.726 84.487 200.702 84.6358C200.678 84.7846 200.618 84.9251 200.526 85.0447C200.435 85.1642 200.315 85.2589 200.177 85.3203L134.628 114.575C134.453 114.653 134.258 114.673 134.07 114.633C133.883 114.593 133.713 114.495 133.585 114.352L116.152 94.8854L182.1 67.2635Z",
    fill: "#0E84E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.67 38.2605L182.283 67.2635L191.719 65.0764C191.904 65.0334 192.072 64.933 192.197 64.7894C192.322 64.6458 192.398 64.4664 192.416 64.2767C192.433 64.087 192.39 63.8968 192.293 63.733C192.196 63.5692 192.049 63.4402 191.874 63.3645L131.962 37.4045C131.831 37.3476 131.688 37.3227 131.546 37.3316L116.67 38.2605Z",
    fill: "#0E84E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.67 38.2605L51.4253 66.7081L43.1775 65.3221C42.9865 65.2864 42.8121 65.1903 42.68 65.0479C42.5479 64.9055 42.4651 64.7244 42.4439 64.5313C42.4227 64.3382 42.4642 64.1434 42.5622 63.9757C42.6603 63.808 42.8097 63.6763 42.9883 63.6001L104.382 37.1419C104.517 37.0842 104.665 37.0605 104.812 37.0729L116.67 38.2605Z",
    fill: "#0E84E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataWhite);
export default __webpack_public_path__ + "static/media/no_data_white.1eb7035b90066cbc8289681b3c443db0.svg";
export { ForwardRef as ReactComponent };